import React from "react";
import style from "./whatsappWidget.module.css";

const WhatsAppWidget = () => {
  const number = "+447493678110";
  const message = encodeURIComponent(
    "Hello, I have a query regarding your product."
  );
  const link = `https://wa.me/${number}?text=${message}`;

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className={style.whatsappFloat}
      aria-label="Chat on WhatsApp"
    >
      <i className="fa fa-whatsapp whatsapp-icon" />
    </a>
  );
};

export default WhatsAppWidget;
